import { Home, Leaf, ChefHat, ShoppingCart, Heart, Lightbulb } from "lucide-react";

export const M = (f) => `/media/${f}`;

export const FEATURES = [
  {
    slug: "household-profile", no: "01", icon: Home, title: "Household Profile",
    short: "Tell Honesti about your family, preferences, dietary needs and goals.",
    card: M("c_card_household.jpg"), hero: M("household.jpg"),
    lines: ["Your family,", "understood."],
    intro: "Every household is different. A profile lets Honesti start from who you actually are — the people at your table, the foods you love, the ones you avoid, and the goals you are working toward together.",
    points: [["Everyone at the table", "Ages, appetites and the picky eater who only likes crunchy things."], ["Needs, not guesses", "Allergies, dietary choices and cultural preferences come first."], ["Goals you set", "Eat more vegetables, save time on weeknights, waste less food."]],
  },
  {
    slug: "meal-recommendations", no: "02", icon: Leaf, title: "Personalized Recommendations",
    short: "Get tailored meal ideas, ingredient swaps and smart suggestions for your home.",
    card: M("c_card_meal.jpg"), hero: M("meals.jpg"),
    lines: ["Dinner ideas", "that fit — and why."],
    intro: "Instead of an endless feed of recipes, Honesti would offer a few thoughtful options and explain exactly why each one fits your family tonight.",
    points: [["A short, thoughtful list", "Three good options instead of three hundred."], ["Why this fits", "Plain-language reasons behind every suggestion."], ["Smart swaps", "Ingredient alternatives for allergies, budget or what you have."]],
  },
  {
    slug: "guided-cooking", no: "03", icon: ChefHat, title: "Guided Cooking",
    short: "Step-by-step support while you cook, with helpful tips and confidence along the way.",
    card: M("c_card_cook.jpg"), hero: M("cooking.jpg"),
    lines: ["Cook with", "a calm guide."],
    intro: "Honesti would walk beside you one step at a time — timing, technique and gentle encouragement — so new cooks and busy parents both feel confident at the stove.",
    points: [["One step at a time", "Clear instructions sized to what your hands are doing."], ["Tips in the moment", "Why the pan should be hot, when to flip, what done looks like."], ["Kids can help", "Age-appropriate jobs so the whole family can join in."]],
  },
  {
    slug: "pantry-shopping", no: "04", icon: ShoppingCart, title: "Pantry & Shopping List",
    short: "See what to use now and what to get next, with organized lists that make life easier.",
    card: M("c_card_pantry.jpg"), hero: M("pantry.jpg"),
    lines: ["Use what you have.", "Get what you need."],
    intro: "Honesti would keep a light picture of your pantry, suggest meals that use what is already there, and build an organized shopping list for the rest.",
    points: [["Use it up", "Meals that start from ingredients you already own."], ["Organized lists", "Grouped by aisle so trips are quicker."], ["Less waste", "Gentle nudges before produce goes past its best."]],
  },
  {
    slug: "feedback-memory", no: "05", icon: Heart, title: "Feedback & Memory",
    short: "The more you use Honesti, the more personalized and helpful she becomes for your family.",
    card: M("c_card_memory.jpg"), hero: M("feedback.jpg"),
    lines: ["She remembers", "what matters."],
    intro: "A quick thumbs up or a note like ‘too spicy for Maya’ would help Honesti learn your family’s tastes over time — and you would always be able to see and edit what she remembers.",
    points: [["Simple feedback", "A tap, a rating or a short note after dinner."], ["Visible memory", "See every preference Honesti has learned."], ["You stay in control", "Edit or forget anything, anytime."]],
  },
];

export const WHY_CARD = {
  slug: "meal-recommendations", icon: Lightbulb, title: "Why This Fits",
  short: "Understand the “why” behind each recommendation based on your family’s needs and goals.",
  card: M("c_card_why.jpg"),
};

export const featurePath = (slug) => `/features/${slug}`;

export const JOURNEY = [
  { title: "Share", text: "Tell Honesti about your family, what you have and what you’re looking for.", img: M("c_j_share.jpg"), to: featurePath("household-profile") },
  { title: "Decide", text: "Get personalized options with clear reasons and helpful tips.", img: M("c_j_decide.jpg"), to: featurePath("meal-recommendations") },
  { title: "Cook", text: "Follow step-by-step guidance with confidence.", img: M("c_j_cook.jpg"), to: featurePath("guided-cooking") },
  { title: "Learn", text: "Build healthier habits together, and get even better recommendations over time.", img: M("c_j_learn.jpg"), to: featurePath("feedback-memory") },
];

export const RECIPES = [
  { name: "Garlic Herb Chicken & Vegetables", time: "25 min", img: M("c_dish1.jpg") },
  { name: "Zucchini Mushroom Stir-Fry", time: "15 min", img: M("c_dish2.jpg") },
  { name: "Quick Honey Glazed Salmon", time: "26 min", img: M("c_dish3.jpg") },
];
